import { atom } from 'jotai';

export const activeAudioOutputAtom = atom({});

export const isPublishingAtom = atom(false);

export const noPermissionsAcknowledgedAtom = atom(false);

export const permissionsAtom = atom({ microphone: false, camera: false, audioOnly: false, acceptNoDevices: false });

export const recordingTimerAtom = atom(0);

export const testRecordingAtom = atom([]);
export const testRecordingProgressAtom = atom(0);
export const testStatusAtom = atom();
